import React from "react";
import { FaInstagram } from "@react-icons/all-files/fa/FaInstagram";
import { FaPinterest } from "@react-icons/all-files/fa/FaPinterest";
import { FaFacebook } from "@react-icons/all-files/fa/FaFacebook";
import { SiTiktok } from "@react-icons/all-files/si/SiTiktok";
import { BiEnvelope } from "@react-icons/all-files/bi/BiEnvelope";
import Obfuscate from "react-obfuscate";

function NavSocialExternalLink({ href, children, className, label }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`px-2 py-2 ${className}`}
      aria-label={label}
    >
      {children}
    </a>
  );
}

export default function NavSocial({ className }) {
  return (
    <div className="flex">
      <NavSocialExternalLink
        href="https://www.instagram.com/lostwithlydia/"
        className={className}
        label="LostWithLydia Instagram"
      >
        <FaInstagram />
      </NavSocialExternalLink>
      <NavSocialExternalLink
        href="https://www.pinterest.com/lostwithlydia/"
        className={className}
        label="LostWithLydia Pinterest"
      >
        <FaPinterest />
      </NavSocialExternalLink>
      <NavSocialExternalLink
        href="https://www.facebook.com/lostwithlydia/"
        className={className}
        label="LostWithLydia Facebook"
      >
        <FaFacebook />
      </NavSocialExternalLink>
      <NavSocialExternalLink
        href="https://www.tiktok.com/@lostwithlydia"
        className={className}
        label="LostWithLydia TikTok"
      >
        <SiTiktok />
      </NavSocialExternalLink>
      <Obfuscate
        email="info@lostwithlydia.com"
        className={`px-2 py-2 ${className}`}
        aria-label="LostWithLydia Email"
      >
        <BiEnvelope />
      </Obfuscate>
    </div>
  );
}
